import { useCoreServices } from '@bangle.io/context';
import { FunMissing, TypoCat } from '@bangle.io/ui-components';
import React from 'react';
import { NoticeView } from './notice-view';

export function FileNotFoundView() {
  const coreServices = useCoreServices();

  const handleViewAllFiles = () => {
    coreServices.commandDispatcher.dispatch(
      'command::ui:toggle-all-files',
      { prefillInput: undefined },
      'ui',
    );
  };

  return (
    <NoticeView
      title={t.app.fileNotFoundView.title}
      description={
        <>
          {t.app.fileNotFoundView.description}
          <br />
          <FunMissing />
        </>
      }
      illustration={
        <TypoCat pose="owl-ears" className="mx-auto h-32 w-auto" decorative />
      }
      actions={[
        {
          label: t.app.fileNotFoundView.viewAllFilesButton,
          variant: 'outline',
          onClick: handleViewAllFiles,
        },
      ]}
    />
  );
}
